const metadata = {
  fields: [
    'id',
    'status',
    'total_records',
    'processed_records',
    'error',
    'conversion_status',
    'converted_records',
    'conversion_error',
    'evaluation_id',
    'created_at',
    'updated_at',
  ],
}

export default metadata
